<template lang="pug">
  v-container.index(fluid)
    Alerts.alert-formatHtml
    div(style="position:relative")
      v-carousel.carousel(
        continuous
        cycle
        interval=10000
        height="450px"
        hide-delimiter-background
        show-arrows=false
        show-arrows-on-hover
      )
        v-carousel-item(v-for="item in featured" :key="item.title" :src="item.img" :to="item.to")
          v-sheet(color="transparent" height="345px")
            v-row.fill-height(align="center" justify="center")
              .carousel-card.elevation-20.mx-2
                v-card-title.d-flex
                  h2.title.text-center {{item.title}}
                v-card-text
                  span.body-2.text-justify(v-line-clamp="9" v-html="item.description")
      div(style="position:absolute;bottom:50px;width:100%").d-flex.justify-space-around
        v-form(@submit.prevent="submit" style="width:400px")
          v-text-field(
            clearable
            placeholder="Search Open Data Portal"
            label="Search Open Data Portal"
            aria-label="Search Open Data Portal"
            prepend-inner-icon="search"
            hide-details
            v-model="term"
            solo
            height="55px"
          ).elevation-20
    center
    hr(style="width:50%").mx-auto.mt-8.mb-12
    DatasetShowcase(title="Recently Updated", :body="lastUpdated")
    hr(style="width:50%").mx-auto.mt-8.mb-12
    ChartShowcase(title="Open Data Insights")
    hr(style="width:50%").mx-auto.mt-8.mb-12
    AppShowcase(title="Open Data Showcase")
</template>

<script>
import Alerts from "@/components/Alerts.vue";
import ChartShowcase from "@/components/ChartShowcase.vue";
import DatasetShowcase from "@/components/DatasetShowcase.vue";
import AppShowcase from "@/components/AppShowcase.vue";
import service from "../data/service";

export default {
  data: () => ({
    term: "",
    featured: [
      {
        title: "Arlington Open Data",
        description:
          "Welcome to the Arlington County Open Data Portal - your one-stop shop for ready to use data from and about Arlington.",
        img: "arlington.jpg",
        to: "/"
      }
    ],
    lastUpdated: {
      sort: { "s3_details.LastModified": "desc" },
      size: 10
    }
  }),
  mounted() {
    return service.listFeatured().then(data => {
      data.map(a => {
        a.to = `dataset/${a.id}`;
        a.img = a.img_url;
      });
      this.featured = this.featured.concat(data).sort(() => Math.random() - 0.5).slice(0,5);
    });
  },
  components: {
    Alerts,
    DatasetShowcase,
    ChartShowcase,
    AppShowcase
  },
  computed: {
    feat() {
      return this.featured;
    }
  },
  methods: {
    submit() {
      this.$router.push({ path: "results", query: { term: this.term } });
    }
  }
};
</script>

<style lang="stylus">
.alert-formatHtml {
  a {
    color: white !important;
    text-decoration: underline;
  }
}

.index {
  max-width: 1500px;

  .carousel {
    border-radius: 5px;
  }

  .carousel-card {
    background-color: white;
    max-width: 400px;
    border-radius: 5px;
    color: black;

    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: black;
    }
  }

  .vert-spacer {
    height: 80px;
  }
}
</style>
